<template>
  <mdb-container fluid>
    <material-card
      title="Leistungsnachweis"
      card-icon="clipboard-check"
    >
      <template v-slot:actions>
        <mdb-btn
          color="#333"
          class="py-2 px-3 z-depth-0 border border-light rounded"
          @click="modal=!modal"
        >
          <mdb-icon
            color="black"
            icon="plus"
          />
        </mdb-btn>
      </template>
      <template v-slot:content>
        <div class="d-flex justify-content-center">
          <mdb-spinner big v-if="loading"/>
        </div>
        <mdb-accordion
          v-if="certificates.length > 0"
          table
        >
          <mdb-accordion-pane
            v-for="(cert, index) in certificates"
            :key="index"
            class="d-flex mb-2"
            title=""
            type="table"
            :isOpen="openPaneNum==index"
            @pane-clicked="handlePaneOpened(index)"
          >
            <mdb-chip
              color="primary lighten-4 float-left mb-0"
              text="primary"
              slot="title"
              class="px-2 mr-1"
            >
              {{ cert.Datum | dateFormat }}
            </mdb-chip>
            <span
              slot="title"
              class="float-left px-2 mt-1"
            >
              {{ cert.AenderungVon }}
            </span>
            <mdb-badge
              class="mt-1 ml-3 float-right"
              :color="schichtColor(cert.Schicht)"
              pill
              slot="title"
            >
              {{ schichtValue(cert.Schicht) }}
            </mdb-badge>
            <div class="p-2 mb-3 mx-3 mb-4">
              <mdb-tbl
                hover
              >
                <mdb-tbl-head>
                  <tr>
                    <th><strong><i class="fas fa-leaf mr-2" aria-hidden="true"></i>Leistung</strong></th>
                    <th><strong><i class="fas fa-comment mr-2" aria-hidden="true"></i>Kommentar</strong></th>
                  </tr>
                </mdb-tbl-head>
                <mdb-tbl-body
                  v-if="cert.Leistungsnachweis.length > 0"
                >
                  <tr
                    v-for="(details, key) in cert.Leistungsnachweis"
                    :key="key"
                  >
                    <td> {{ details.Text }} </td>
                    <td v-if="details.Kommentar"> {{ details.Kommentar }} </td>
                    <td v-else> - </td>
                  </tr>
                </mdb-tbl-body>
                <list-group-item
                  v-else
                  class="mt-2"
                  :title="'Keine Einträge gefunden'"
                />
              </mdb-tbl>
            </div>
          </mdb-accordion-pane>
        </mdb-accordion>
        <list-group-item
          v-else
          :title="'Keine Einträge gefunden'"
        />
      </template>
    </material-card>
    <add-performance-modal
      :modal-state="modal"
      @close="modal=false"
      @save="saveModal"
    />
  </mdb-container>
</template>

<script>
import {
  mdbContainer,
  mdbBtn,
  mdbIcon,
  mdbBadge,
  mdbAccordion,
  mdbAccordionPane,
  mdbChip,
  mdbTbl,
  mdbTblBody,
  mdbTblHead,
  mdbSpinner
} from 'mdbvue';
const AddPerformanceModal = () => import('@/components/modals/AddPerformanceModal')
const MaterialCard = () => import('@/components/card/MaterialCard')
const ListGroupItem = () => import('@/components/accordion/ListGroupItem')
import utils from '@/mixins/Utils'

export default {
  name: 'Leistungsnachweis',
  mixins: [utils()],
  components: {
    mdbContainer,
    mdbBtn,
    mdbIcon,
    AddPerformanceModal,
    ListGroupItem,
    mdbBadge,
    mdbAccordion,
    mdbAccordionPane,
    mdbChip,
    MaterialCard,
    mdbTbl,
    mdbTblBody,
    mdbTblHead,
    mdbSpinner
  },

  data () {
    return {
      modal: false,
      openPaneNum: 0,
      certificates: [],
      loading: false
    }
  },

  created() {
    this.loadCertificates()
  },

  methods: {
    handlePaneOpened (num) {
      if (this.openPaneNum == num) {
        return (this.openPaneNum = null)
      }
      this.openPaneNum = num;
    },

    saveModal () {
      this.modal = false
      this.loadCertificates()
    },

    loadCertificates () {
      this.loading = true
      this.$http.get(`/Leistungsnachweis/${this.roomID}`)
        .then(res => {
          if(res.data.data) {
            this.certificates = res.data.data
          }
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
